import React from "react";
import RenderCurrentSmartview from "./RenderCurrentSmartview";
import {useUUID} from "@morningtrain/react-resources";

export default function SmartviewMount(props) {

    const uuid = useUUID();

    let Container = props.container;

    if (!Container) {
        throw new Error('Tried to set up smartview mount, but container was not given as a prop to SmartviewMount');
    }

    const inner = <RenderCurrentSmartview key={uuid}/>;

    if (React.isValidElement(Container)) {
        Container = React.cloneElement(Container, {...Container}, inner);
    } else {
        Container = (
            <Container>
                {inner}
            </Container>
        );
    }

    return Container;
}

